import { ServiceDisplayOrderMode } from "@/states/page-editor/template-parts/top";

export interface TopPartInfo {
  partId: string;
  mode: "system" | "custom";
  orderIds?: number[];
  hiddenIds?: number[];
}

export interface DraftBlock {
  key?: string;
  data?: {
    TEMPLATE?: {
      type?: string;
      serviceDisplayOrderType?: string;
      serviceOrderIds?: number[];
      hiddenIds?: number[];
    };
  };
}

/**
 * Find all top parts in template blocks
 * Used for initializing service display data per part
 *
 * @param blocks - Draft.js blocks from template
 * @returns Array of top part info with mode, orderIds, hiddenIds
 */
export const findTopParts = (
  blocks: DraftBlock[] | undefined,
): TopPartInfo[] => {
  if (!blocks) return [];
  const results: TopPartInfo[] = [];

  for (const block of blocks) {
    const template = block.data?.TEMPLATE;
    const blockType = template?.type;
    const displayOrderType = template?.serviceDisplayOrderType;
    const serviceOrderIds = template?.serviceOrderIds;
    const hiddenIds = template?.hiddenIds;

    // Check if this is a top part type (only top and top.1 have service list)
    if (blockType === "top" || blockType === "top.1") {
      const partId = block.key ?? "";
      const mode =
        displayOrderType === ServiceDisplayOrderMode.CUSTOM
          ? "custom"
          : "system";
      results.push({
        partId,
        mode,
        orderIds: serviceOrderIds,
        hiddenIds: hiddenIds,
      });
    }
  }

  return results;
};
